import {BaseContainerModel} from '../base-container.model';
import {bl_applet_store_hdr_RowClass} from '../../dbschema/bl_applet_store_hdr.model';
import {bl_applet_store_ext_RowInterface} from '../../dbschema/bl_applet_store_ext.model';

export class StoreContainerModel extends BaseContainerModel {
  bl_applet_store_hdr: bl_applet_store_hdr_RowClass = new bl_applet_store_hdr_RowClass();
  bl_applet_store_exts: bl_applet_store_ext_RowInterface[] = [];
}
